<template>
  <div>
    <v-dialog
      scrollable
      persistent
      :value="providerInternal !== null"
      max-width="600"
    >
      <material-card
        :title="$t('Edit Provider')"
        :color="$vuetify.theme.themes.light.primary"
        icon="edit"
        v-if="providerInternal !== undefined && providerInternal !== null"
      >
        <v-card-text>
          <v-form :disabled="loading" ref="form" v-model="valid">
            <v-container>
              <div class="row">
                <div class="col-12 col-md-12">
                  <trans-textbox
                    :label="$t('globals.name')"
                    v-model="providerInternal"
                    field="Name"
                    :rules="[$rules.required]"
                    class="required"
                  />
                </div>

                <div class="col-12 col-md-12">
                  <trans-textarea
                  :label="$t('globals.description')"
                    v-model="providerInternal"
                    field="Description"
                    :rules="[$rules.required]"
                    class="required"
                  />
                </div>

                <div class="col-12 col-md-12">
                  <no-autocomplete-textfield
                  :label="$t('globals.address')"
                    v-model="providerInternal.Address"
                    :rules="[$rules.required]"
                    class="required"
                  />
                </div>
                <div class="col-12 col-md-4">
                  <!-- <no-autocomplete-textfield
                    label="Phone"
                    v-model="providerInternal.Phone"
                    :rules="[$rules.required, rules.phone]"
                    class="required"
                    v-mask="telephoneMask"
                  /> -->
                  <no-autocomplete-textfield
                  :label="$t('globals.phone')"
                    v-model="providerInternal.Phone"
                    :rules="[$rules.required, $rules.phone]"
                    class="required"
                  />
                </div>
                <div class="col-12 col-md-4">
                  <no-autocomplete-textfield
                    type="number"
                    :label="$t('globals.order')"
                    v-model="providerInternal.Order"
                    :rules="[$rules.required]"
                    class="required"
                  />
                </div>
                <div class="col-12 col-md-4">
                  <v-checkbox
                  :label="$t('globals.active')"
                    v-model="providerInternal.IsActive"
                  />
                </div>
                <v-container v-if="cms==='old'">
                  <div
                    v-for="trans of providerInternal.Translations"
                    v-bind:key="trans.LanguageCode"
                  >
                    <div class="row">
                      <h5 style="margin-left:5px">{{ trans.LanguageCode }}</h5>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="title">{{ $t('globals.logo') }}</div>
                        <image-picker :image.sync="trans.Image"></image-picker>
                      </div>
                    </div>
                  </div>
                </v-container>
              </div>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            :disabled="loading"
            @click="
              providerInternal = null;
              $emit('cancel');
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" :loading="loading" @click="save()">
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
        <error-handler :error="error"></error-handler>
      </material-card>
    </v-dialog>
  </div>
</template>

<script>
import deepClone from "../../utils/deepClone";
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../../components/ErrorHandler";
import TransTextbox from "../TransTextbox.vue";
import TransTextarea from "../TransTextarea.vue";
import ImagePicker from "../ImagePicker.vue";
import NoAutocompleteTextfield from "../../components/NoAutocompleteTextfield";
import { tokens, mask } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";
export default {
  components: {
    ErrorHandler,
    TransTextbox,
    ImagePicker,
    TransTextarea,
    NoAutocompleteTextfield,
  },
  props: {
    provider: Object,
    cms: String
  },
  directives: { mask },
  data: () => ({
    rules: {
      phone: (v) => {
        let val = this.unmask(v, this.telephoneMask);
        return !val || this.$rules.phone(val);
      },
    },
    telephoneMask: "(###) ### - ####",
    valid: false,
    providerInternal: null,
    loading: false,
    error: null,
  }),
  watch: {
    provider: {
      handler(val) {
        this.providerInternal = deepClone(this.provider);
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions("downloadCenter", ["saveProvider"]),
    unmask(v, mask) {
      if (v) {
        return masker(v, mask, false, tokens);
      }
      return v;
    },
    async save() {
      const clone = deepClone(this.providerInternal);
      for (const t of clone.Translations) {
        if (t.Image) {
          t.ImageId = t.Image.Id;
          t.Image = null;
        }
      }
      await this.withLoad(this.saveProvider(this.providerInternal));
      this.$emit("update:provider", this.providerInternal);
    },
    async withLoad(promise) {
      this.error = null;
      this.loading = true;
      try {
        await promise;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
